<template>
    <router-view class="app" />
    <!-- 报警信息弹框 -->
    <el-dialog v-model="alertShow" width="50%" center
        style="background-color: #ffffffee;border-radius:15px;margin-top: 5%;height:700px" @close="onOkSeeAlarm">
        <span
            style="text-align: center;width: 100%;display: block;font-size: 20px;color: red; padding: 10px;box-sizing: border-box;margin-bottom: 10px;">
            当前有<span style="font-size: 24px;font-weight: 600;margin: 0 10px;">{{ AlarmDataPopup.length
                }}</span>条信息待查看
        </span>
        <!-- <el-table  :data="AlarmDataPopup" @row-click="onRowClick"  style="height: 500px;width: 100%;overflow: auto;background-color: #fff;border-radius: 15px;display: block;"> -->
        <!-- <el-table-column prop="organizationName" label="维保公司" /> -->
        <!-- <el-table-column prop="itemName" label="项目单位" /> -->
        <!-- <el-table-column prop="type" label="违规类型" /> -->
        <!-- <el-table-column prop="msg" label="违规内容"  width="500"/> -->
        <!-- <el-table-column prop="msg" label="器材名称" /> -->
        <!-- </el-table> -->

        <table
            style="height: 500px;width: 100%;overflow: auto;background-color: #fff;border-radius: 15px;display: block;">
            <tr v-for="(item, index) in AlarmDataPopup" :key="index" style="display: block;">
                <td @click="ontdtdtd(item)"
                    style="line-height:20px ; height: 100%;padding: 5px;box-sizing: border-box;text-align: center;">
                    <!-- <el-link style="font-size: 16px;"  
                    href="/home/unitdata?id=0"
                     target="_blank" type="default">  -->
                    {{ item.message }}
                    <!-- </el-link> -->
                </td>
            </tr>
        </table>

        <template #footer>
            <span class="dialog-footer">
                <!--<el-button type="primary" @click="onLookMessage">
                    前往查看
                </el-button>-->
                <el-button type="danger" @click="onOkSeeAlarm">
                    关闭
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { provide, onMounted, onUnmounted, ref, watch } from "vue"
import { decrypt } from '@/utils/cryptoAES.js';
import { useMobileStore } from '@/store/mobile.js';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter()
const route = useRoute()
const useMobile=useMobileStore()
let AlarmDataPopup = ref([])
let alertShow = ref(false)
let socket
let flag = 'close'
let sto
let count = ref(1)
let IllegalMessage = ref([])
let tableBg=ref('linear-gradient(to top, rgb(0, 139, 30), rgb(228, 228, 29))')
const init = () => {
    const userAgent = navigator.userAgent.toLowerCase();
  const mobileAgents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod"];
 let isMobile = mobileAgents.some(agent => userAgent.includes(agent));
 console.log('isMobile',isMobile)
 useMobile.updateMobile(isMobile)
    if (window.localStorage.getItem('regulatoryBody')) {
        let fireData = ref(JSON.parse(decrypt(window.localStorage.getItem('regulatoryBody'))))
        // socket = new WebSocket(`ws://192.168.1.14:51804/webSocketZD/${fireData.value.id}`)
        socket = new WebSocket(`ws://10.0.0.210:51806/webSocketZD/${fireData.value.id}`)
        socket.onopen = () => {
            if (flag === 'padding') {
                location.reload()
            }
            flag = 'success'
            console.log('websocket success');
        }
        socket.onmessage = (event) => {
            // console.log('71', JSON.parse(event.data))
            let result = JSON.parse(event.data)
            AlarmDataPopup.value.unshift(result)
            AlarmDataPopup.value = AlarmDataPopup.value.map(item => {
                return {
                    ...item,
                    message: `${item.createTime ? item.createTime : ' '}${item.createTime ? '\u00A0\u00A0\u00A0\u00A0\u00A0' : ' '} ${item.itemName}\u00A0\u00A0\u00A0\u00A0\u00A0${item.msg} `
                }
            })
            if (window.localStorage.getItem('switch') === 'true') {
                alertShow.value = true
            } else if (window.localStorage.getItem('switch') === 'false') {
                alertShow.value = false
            }
        }
        socket.onclose = () => {
            console.log('websocket close');
            flag = 'padding'
            if (flag === 'padding') {
                socket.close()
                sto = setTimeout(() => {
                    init()
                }, 2000)
            }
            else {
                location.reload()
                return clearTimeout(sto)
            }
        }
        provide('socket', socket)
    }


}
const onOkSeeAlarm = () => {
    AlarmDataPopup.value = []
    alertShow.value = false
}

const ontdtdtd = (row) => {
    console.log(row)
    // router.push({ path: '/home/unitdata', query: { id: row.organizationId, name: row.organizationName,dataName:'维保计划',value:3 } });
    let val = {
        id: row.organizationId,
        name: row.organizationName,
        dataName: '维保计划',
        value: 3,
        itemId: row.itemId,//76
    }
    router.push({ path: '/home/unitdata', query: val })


    alertShow.value = false
}
// const onLookMessage = () => {
//     router.push({ path: '/home/illegalInformation' });
//     alertShow.value = false

// }
onMounted(() => {
    init()
    // window.onbeforeunload = () => {
    //     socket.close();
    // }

})

</script>

<style lang="scss">
.el-text {
    cursor: pointer;
}

.el-tag {
    cursor: pointer;
}

// 表头
th.el-table__cell {
    // background-image: linear-gradient(to top, rgb(127, 179, 136), rgb(240, 240, 177)) !important ; 
    background: v-bind(tableBg);
    color: #ffffff !important;
}

.el-table {
    width: 98% !important;
    background-color: rgba($color: #fff, $alpha: .4) !important;
    margin: 10px auto;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 10px 20px 10px #e2e2e2;
}

// 表体
.el-table__inner-wrapper {
    background-color: transparent !important;
    color: #000;
    border-bottom: 0;
}


.option {
    width: 98% !important;
    margin: 10px auto 0px !important;
    background-color: rgba($color: #fff, $alpha: .4) !important;
    border-radius: 10px !important;
    box-shadow: 0 0 10px 5px #e2e2e2;
    padding: 10px 15px !important;
    box-sizing: border-box;

}

.el-input-number__decrease,
.el-input-number__increase {
    display: none !important;
}

.el-input__wrapper {
    padding: 0 15px !important;
}

.el-message {
    top: 10px !important;
    left: 84% !important;
}

// image_error


.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: var(--el-fill-color-light);
    color: var(--el-text-color-secondary);
}

.image-slot .el-icon {
    font-size: 16px !important;
}

::-webkit-scrollbar {
    width: 0 !important;
}
</style>
